var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-breadcrumb',{staticStyle:{"padding":"16px 10px 10px 20px","font-size":"16px","border-bottom":"1px solid","margin-bottom":"20px"},attrs:{"separator":">"}},[_vm._v(" 当前位置："),_vm._l((_vm.$route.meta.breadcrumb),function(item,index){return _c('a-breadcrumb-item',{key:index},[_vm._v(_vm._s(item))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }